export default __webpack_public_path__ + "static/media/youtube.89304f43.webp";